/* src/app/master-data/customers/locations/locations-list/locations-list.component.css */
/*# sourceMappingURL=locations-list.component-5ZE4D4NO.css.map */
